import { useState } from 'react';
import type { StorageMode } from '../../store/types.ts';
import { DEFAULT_MODEL } from '../../store/types.ts';

type SettingsModalProps = {
  open: boolean;
  model: string;
  keyStorageMode: StorageMode;
  apiKey: string;
  onClose: () => void;
  onUpdateModel: (model: string) => void;
  onUpdateKeyStorageMode: (mode: StorageMode) => void;
  onUpdateApiKey: (key: string) => void;
  onRerunOnboarding: () => void;
};

export function SettingsModal({
  open,
  model,
  keyStorageMode,
  apiKey,
  onClose,
  onUpdateModel,
  onUpdateKeyStorageMode,
  onUpdateApiKey,
  onRerunOnboarding,
}: SettingsModalProps) {
  const [showKey, setShowKey] = useState(false);

  if (!open) return null;

  return (
    <div className="ds-modal-overlay" role="dialog" aria-modal="true" aria-label="Settings">
      <div className="ds-modal">
        <div className="ds-modal__head">
          <h3 className="ds-modal__title">Settings</h3>
          <button type="button" className="ds-btn ds-btn--sm ds-btn--ghost" onClick={onClose}>
            Close
          </button>
        </div>

        <div className="ds-field">
          <span className="ds-field__label">Claude model</span>
          <input
            className="ds-field__input"
            value={model}
            onChange={(e) => onUpdateModel(e.target.value)}
            placeholder={DEFAULT_MODEL}
          />
        </div>

        <fieldset className="ds-fieldset">
          <legend>API key storage</legend>
          <label className="ds-radio">
            <input
              type="radio"
              checked={keyStorageMode === 'session'}
              onChange={() => onUpdateKeyStorageMode('session')}
            />
            <span className="ds-radio__text">
              Session only (recommended)
              <small className="ds-radio__hint">Key removed when browser session ends.</small>
            </span>
          </label>
          <label className="ds-radio">
            <input
              type="radio"
              checked={keyStorageMode === 'local'}
              onChange={() => onUpdateKeyStorageMode('local')}
            />
            <span className="ds-radio__text">
              Remember on this device
              <small className="ds-radio__hint">Stored in localStorage until cleared.</small>
            </span>
          </label>
        </fieldset>

        <div className="ds-field">
          <span className="ds-field__label">Anthropic API key</span>
          <div className="ds-api-row">
            <input
              className="ds-field__input"
              type={showKey ? 'text' : 'password'}
              value={apiKey}
              onChange={(e) => onUpdateApiKey(e.target.value)}
              placeholder="sk-ant-..."
            />
            <button type="button" className="ds-btn ds-btn--sm" onClick={() => setShowKey((v) => !v)}>
              {showKey ? 'Hide' : 'Show'}
            </button>
            <button type="button" className="ds-btn ds-btn--sm ds-btn--danger" onClick={() => onUpdateApiKey('')}>
              Clear
            </button>
          </div>
        </div>

        <div className="ds-note">
          <strong>Security:</strong> This app calls Anthropic directly from the browser (BYOK). For stronger production security, route requests through your own backend.
        </div>

        <div className="ds-modal__actions">
          <button type="button" className="ds-btn ds-btn--ghost" onClick={onRerunOnboarding}>
            Re-run onboarding
          </button>
          <button type="button" className="ds-btn ds-btn--primary" onClick={onClose}>
            Done
          </button>
        </div>
      </div>
    </div>
  );
}
